import injector from '@/libs/dependency-injector';

// Export injector
export default injector();
